module.exports = __webpack_public_path__ + "img/s7.083afd52.png";